export function convertToNumber(param: any) {
  const result = parseFloat(param);
  return isNaN(result) ? 0 : result;
}
